<template>
  <v-main>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>

          <!-- HEADER -->
          <h1 class="mb-4">{{$t("Set weight")}}</h1>
          <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>

          <div style="max-width:1100px">
            <!-- SUMMARY -->
            <div v-if="wlReg != null && wlReg.Registration != null">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-layout v-if="!isHide('Article')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Article")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{wlReg.Registration.ArticleNo}} - {{wlReg.Registration.ArticleName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Vehicle')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Vehicle")}}:</v-flex>
                    <v-flex d-flex xs8>{{wlReg.Registration.VehicleNo}} - {{wlReg.Registration.VehicleLicensePlateNo}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Customer')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Customer")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{wlReg.Registration.CustomerNo}} - {{wlReg.Registration.CustomerName}}</v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Weight")}}:</v-flex>
                    <v-flex d-flex xs8>{{getWeightStr(wlReg)}}</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                  <v-layout v-if="!isHide('RequisitionNo1')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("RequisitionNo1")}}:</v-flex>
                    <v-flex d-flex xs8>{{wlReg.Registration.RequisitionNo1}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('RequisitionNo2')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("RequisitionNo2")}}:</v-flex>
                    <v-flex d-flex xs8>{{wlReg.Registration.RequisitionNo2}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Plant')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Plant")}}:</v-flex>
                    <v-flex d-flex xs8>{{wlReg.Registration.PlantNo}} - {{wlReg.Registration.PlantName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Facility')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Facility")}}:</v-flex>
                    <v-flex d-flex xs8>{{wlReg.Registration.Facility}}</v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>

            <div>
              <v-layout xs12 sm12 align-center >
                <v-flex>
                  <v-text-field  v-if="wlReg != null && wlReg.Registration != null && !isHide('Comment')" class="ml-2 mr-2" hide-details="true" v-model="wlReg.Registration.Comment1" :maxlength="100" :label="$t('Comment')"></v-text-field>
                  <!-- WEIGHT DISPLAY -->
                  <v-layout row wrap class="textsize-svs" style="padding: 10px 8px 4px 8px" >
                    <v-flex d-flex xs12 sm12 class="textsize-large thin-border" style="min-height:50px; align-items:center; justify-content:center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                      <div class="text-center">
                        {{form.weightNetString}} kg
                      </div>
                    </v-flex>
                  </v-layout>

                  <!-- WHEEL LOADER BUTTON -->
                  <v-flex v-if="enableVT25WeightIntegration" d-flex xs12 sm12 class="textsize-svs">
                    <v-btn :disabled="!isAlive" block color="info" class="numPadBtn text-lowercase"
                        @click="disableConfirmTransferDialog || !activeVT25 ? get_Wheel_Loader_Weight() : confirmTransferDialog = true"
                        @contextmenu="wheelLoaderIdHandler($event)">
                      <v-icon x-large>arrow_drop_up</v-icon>
                      <div><div v-html="wheelloaderIcon"></div><div class="textsize-vt25 ml-n3 mt-n4 text-uppercase">{{ activeVT25 ? activeVT25 : '?' }}</div></div>
                      <div>{{ displayWeight }}</div>
                      <v-icon x-large>arrow_drop_up</v-icon>
                    </v-btn>
                  </v-flex>

                  <!-- NUM PAD -->
                  <v-flex d-flex sm2></v-flex>
                  <v-layout row class="textsize-svs">
                    <v-flex d-flex class="ml-n5" xs1 sm1></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(7)">7</v-btn></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(8)">8</v-btn></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(9)">9</v-btn></v-flex>
                    <v-flex d-flex xs2 sm3><v-btn block color="warning" class="txtPadBtn" @click="weightRemove()"><v-icon class="d-md-none">backspace</v-icon><div class="d-none d-md-block">C</div></v-btn></v-flex>
                    <v-flex d-flex xs1 sm1></v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs">
                    <v-flex d-flex class="ml-n5" xs1 sm1></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(4)">4</v-btn></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(5)">5</v-btn></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(6)">6</v-btn></v-flex>
                    <v-flex d-flex xs2 sm3><v-btn block color="error" class="txtPadBtn" @click="preventLeave = false; changeSetWeightStatus(''); $router.go(-1)"><v-icon class="d-md-none">cancel</v-icon><div class="d-none d-md-block">{{$t("Cancel")}}</div></v-btn></v-flex>
                    <v-flex d-flex xs1 sm1></v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs">
                    <v-flex d-flex class="ml-n5" xs1 sm1></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(1)">1</v-btn></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(2)">2</v-btn></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(3)">3</v-btn></v-flex>
                    <v-flex d-flex xs2 sm3><v-btn block color="success" class="txtPadBtn" @click="submit()" :loading="submitting"><v-icon class="d-md-none">done</v-icon><div class="d-none d-md-block">{{$t("Ok")}} {{buttonAppend}}</div></v-btn></v-flex>
                    <v-flex d-flex xs1 sm1></v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs">
                    <v-flex d-flex class="ml-n5" xs1 sm1></v-flex>
                    <v-flex d-flex xs3 sm4><v-btn block color="primary" class="numPadBtn" @click="weightAppend(0)">0</v-btn></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(decimalSeparator)">{{decimalSeparator}}</v-btn></v-flex>
                    <v-flex d-flex xs5 sm3><v-btn block color="success" class="txtPadBtn" @click="form.weightNetString === '0' ? confirmZeroKgDialog=true : finishRegistration()" :loading="submitting">{{$t("Finish")}} {{buttonAppend}}</v-btn></v-flex>
                    <v-flex d-flex xs1 sm1></v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </v-flex>

        <!-- ACCEPT TRANSFER DIALOG -->
        <v-dialog v-model="confirmTransferDialog" max-width="450" persistent>
          <v-card>
            <v-card-title class="headline">{{$t("Transfer and reset weight?")}}</v-card-title>
            <v-card-text>
              {{$t("Accept to transfer the device sum weight and reset the sum now. (This is not undoable)")}}
            </v-card-text>
            <v-divider class="mb-0"></v-divider>
            <v-card-actions>
              <v-checkbox small :label="$t('Never show dialog again')" v-model="disableConfirmTransferDialog" :color="'primary'"></v-checkbox>
              <v-spacer></v-spacer>
              <v-btn x-large color="success" @click="confirmTransferDialog = false; savedisableConfirmTransferDialog(); get_Wheel_Loader_Weight()">{{$t("Yes")}}</v-btn>
              <v-btn x-large color="primary" @click="confirmTransferDialog = false">{{$t("No")}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- SELECT ACTIVE WHEEL LOADER DIALOG -->
        <v-dialog v-model="wheelLoaderIdDialog" max-width="380" persistent>
          <v-card >
            <v-card-title @click="simulateWeightFromWheelLoader" class="headline">{{$t("Wheel loader weight input")}}</v-card-title>
            <v-divider class="mb-0"></v-divider>
            <v-card-actions>
              <v-card-text>
              <v-select class="mt-n2 mb-6" hide-details="true" :clearable="true" :items="VT25List" v-model="selectedVT25" :label="$t('Select active Wheel loader')"></v-select>
              <v-btn class="ml-9" x-large color="success" @click="wheelLoaderIdDialog = false; saveVT25(selectedVT25)">{{$t("Ok")}}</v-btn>
              <v-btn class="ml-4" x-large color="primary" @click="wheelLoaderIdDialog = false">{{$t("Cancel")}}</v-btn>
            </v-card-text>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="confirmZeroKgDialog" max-width="350">
          <v-card>
            <v-card-title class="headline">{{$t("NoWeightAdded")}}</v-card-title>
            <v-card-text>{{$t("NoWeightAddedDescription")}}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="confirmZeroKgDialog = false; finishRegistration();">{{$t("NoWeightAnswerYes")}}</v-btn>
              <v-btn color="primary" @click="confirmZeroKgDialog = false">{{$t("NoWeightAnswerNo")}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import * as WheelLoader from '@/modules/wheel-loader/wheel-loader'
import ct from '@/core/mixins/common-translations'
import rules from '@/core/mixins/common-rules'
import preventLeave from '@/core/mixins/preventLeave'
import SVGIcons from '@/assets/svg/SVGIcons'
import * as LocalStorage from '@/core/local-storage'
import * as Security from '@/core/security'
import * as DateUtil from '@/core/date'
import * as Log from '@/core/logger'

export default {
  mixins: [ct, rules, preventLeave],
  data: () => ({
    dataType: 'wheel-loader-registration',
    loading: true,
    submitting: false,
    confirmTransferDialog: false,
    disableConfirmTransferDialog: false,
    confirmZeroKgDialog: false,
    valid: true,
    redirectTo: 'wheel-loader-registrations',
    decimalSeparator: ',',
    maxDecimalCount: 2,
    userName: Security.user.name.split('.')[1], // set username ex. SVS.Ole => Ole
    form: {
      weightNet: 0,
      weightNetString: ''
    },
    wlReg: {
      id: '00000000-0000-0000-0000-000000000000',
      registrationId: '00000000-0000-0000-0000-000000000000',
      facilityNo: null,
      finishedDate: null,
      finishedBy: null,
      comment: null,
      reg: null
    },
    wheelloaderIcon: SVGIcons.WheelLoaderLargeIcon,
    enableVT25WeightIntegration: false,
    isAlive: true,
    // WK60IpPort: '0.0.0.0:1234',
    checkIsAliveTimer: null,
    checkkingIsAlive: false,
    activeVT25: null,
    selectedVT25: null,
    displayWeight: '',
    wheelLoaderIdDialog: false,
    VT25List: [],
    allowSimulation: false, // if VT25List from server is empty allow simulation weight for 'VT25 #1' and 'VT25 #2' by left click on the weight
    simulationWeight: 0,
    firstErrorStatus: '',

    errorTexts: [
      { text: 'Z', value: 'The scale must be set to zero.' },
      { text: 'WU', value: 'Warm-up strokes must be performed.' },
      { text: 'W', value: 'Weighing allowed.' },
      { text: 'WB', value: 'As for Weighing allowed, but with re-weighing active.' },
      { text: 'F', value: 'The contents of the bucket have been weighed and added. The loading bucket must be emptied.' },
      { text: 'S', value: 'Scale in standby mode. Check WK60 is ON. If ON, press "Stand-By" and touch screen, to turn ON again.' },
      { text: 'ENA', value: 'Error: top of zero range exceeded.' },
      { text: 'ENI', value: 'Error: bottom of zero range exceeded.' },
      { text: 'ES', value: 'Error: unstable weighing process.' },
      { text: 'EWA', value: 'Error: maximum load exceeded.' },
      { text: 'EWI', value: 'Error: minimum load required.' },
      { text: 'ET', value: 'Error: vehicle is tilted.' },
      { text: 'ELSF', value: 'Error: Alibi memory is full.' },
      { text: 'ZERO', value: 'The scale cannot be set to zero. Check WK60 is ON. If ON, press "Stand-By" and touch screen, to turn ON again.' },
      { text: 'NoWeight', value: 'No Weight data ready. Please wait. Check WK60 is ON. If ON, press "Stand-By" and touch screen, to turn ON again.' },
      { text: 'Timeout', value: 'Timeout. Weight data too old (>10 secs). Please wait and try again.' },
      { text: 'ResetWeight', value: 'The scale must be reset to zero. Please wait and try again.' }
    ],
    hiddenFields: []
  }),
  computed: {},
  methods: {
    getWeightStr (wlReg) {
      if (wlReg && wlReg.CreatedBy.startsWith('corp:')) {
        // Weighing is via weightbridge
        if (wlReg.Registration.Completed) {
          return wlReg.Registration.WeightNet + ' kg'
        } else {
          return wlReg.Registration.WeightFirst + ' kg (' + this.$t('WeightFirst') + ')' // Vehicle has only done a first weighing
        }
      } else {
        // Weighing is via wheelloader
        return Math.abs(wlReg.Registration.WeightFirst - wlReg.Registration.WeightSecond) + ' kg'
      }
    },
    async finishRegistration () {
      // Grab an update of the reg to get ScanXRegNo etc.
      const res2 = await WheelLoader.loadRegistration(this.wlReg.id)
      if (!res2.failed) {
        const comment = this.wlReg.Registration.Comment1
        this.wlReg.Registration = res2.data.Registration
        this.wlReg.Registration.Comment1 = comment
      }

      var convertedValue = this.checkWeightInput()
      if (convertedValue == null) return
      this.updateWeight(convertedValue)
      this.submitting = true
      this.confirmDialog = false
      this.preventLeave = false
      const res = await WheelLoader.saveRegistration({
        Id: this.wlReg.id,
        RegistrationId: this.wlReg.registrationId,
        Facility: this.wlReg.facilityNo,
        FinishedDate: new Date(),
        FinishedBy: this.wlReg.finishedBy,
        Comment: this.wlReg.comment,
        Registration: this.wlReg.Registration
      })
      this.submitting = false
      if (!res.failed) {
        this.preventLeave = false
        this.$root.$message.showSuccess(this.$t('Registration finished'))
        this.$router.push({ name: this.redirectTo })
      }
    },
    // Append the char to the weight
    weightAppend (char) {
      // Start checking the rules.
      if (this.form.weightNetString === '0') {
        if (char >= 1 && char <= 9) {
          // If already entered 0, and entering a value between 1 and 9, then remove the 0.
          this.form.weightNetString = ''
        } else if (char === 0) {
          // If already entered 0, and entering 0 again, then ignore it.
          return
        }
      } else if (this.form.weightNetString === '') {
        if (char === this.form.decimalSeparator) {
          // If the string is empty, and entering comma, then add a 0 first.
          this.form.weightNetString = '0'
        }
      } else if (this.form.weightNetString.indexOf(this.form.decimalSeparator) > -1) {
        if (char === this.form.decimalSeparator) {
          // If the string already contains a comma, and entering comma again, then ignore it.
          return
        }

        // Count the number of decimals already entered.
        var decimalCount = this.form.weightNetString.split(this.form.decimalSeparator)[1].length || 0
        if (decimalCount >= this.form.maxDecimalCount) {
          // If more decimals than allowed are already entered, then ignore them.
          // But let's tell the user
          this.$root.$message.showInfo(this.$t('No more decimals are allowed.'))
          return
        }
      }

      // Now append the new char
      this.form.weightNetString += ('' + char)
    },
    weightRemove () {
      // Remove the last char
      this.form.weightNetString = this.form.weightNetString.substr(0, this.form.weightNetString.length - 1)
    },
    checkWeightInput () {
      // Convert the weightNetString to weightNet
      var convertedValue = parseFloat(this.form.weightNetString)
      if (convertedValue === undefined || convertedValue === null || isNaN(convertedValue)) {
        this.$root.$message.showError(this.$t('Invalid format of entered weight'))
        return null
      }

      // The type of WeightNet in the database is a Decimal(18,6)
      // The maximum number of a Decimal(18,6) is (18-6)=12x '9' before the separator and 6x '9' after the separator. So 999999999999,999999
      // Let's just check for 6x '9' without the decimals.
      if (convertedValue > 999999) {
        this.$root.$message.showError(this.$t('WeightTooBig'))
        return null
      }
      return convertedValue
    },
    updateWeight (weight) {
      this.form.weightNet = weight
      this.wlReg.Registration.WeightFirst = this.form.weightNet
      this.wlReg.Registration.WeightSecond = 0
      this.wlReg.Registration.WeightNet = Math.abs(this.wlReg.Registration.WeightFirst - this.wlReg.Registration.WeightSecond)
    },
    savedisableConfirmTransferDialog () {
      if (this.disableConfirmTransferDialog) {
        LocalStorage.save('disableConfirmTransferDialog', this.disableConfirmTransferDialog.toString())
      }
    },
    async get_Wheel_Loader_Weight () {
      // First time Select active VT25
      if (!this.activeVT25) {
        this.wheelLoaderIdDialog = true
        return
      }
      this.isAlive = false // disable WheelLoader button

      // Get WK60 sum weight
      const res = await WheelLoader.getWeight({ VT25Id: this.activeVT25, ResetWeight: 'False' })

      if (!res.failed) {
        if (res.data.Status === 'W') {
          if (res.data.TotalWeight > 0) {
            this.form.weightNetString = res.data.TotalWeight.toString()
            this.updateWeight(res.data.TotalWeight)
            this.$root.$message.showInfo(this.$t('Weight') + ' ' + this.form.weightNetString + ' kg ' + this.$t('transferred'))
            this.firstErrorStatus = ''
            await WheelLoader.getWeight({ VT25Id: this.activeVT25, ResetWeight: 'True' }) // only send reset, ignore weight
          } else {
            this.$root.$message.showError(this.$t('NoWeightAdded') + ' (0 kg)')
          }
        } else {
          if (!this.firstErrorStatus) this.firstErrorStatus = res.data.Status
          const error = this.$t('Weight communication problem. Check WK60 is ON. If ON, press Stand-By and touch screen, to turn ON again.') + ' [Code: ' + this.firstErrorStatus + ']'
          this.$root.$message.showError(error)
          Log.log('Error in get_Wheel_Loader_Weight:', error, res.data)
        }
        this.isAlive = true // enable WheelLoader button
        this.displayWeight = ''
      }
    },
    wheelLoaderIdHandler (event) {
      this.selectedVT25 = this.activeVT25
      this.wheelLoaderIdDialog = !this.wheelLoaderIdDialog
      event.preventDefault()
    },
    saveVT25 () {
      if (this.selectedVT25) {
        this.activeVT25 = this.selectedVT25
        LocalStorage.save('activeVT25', this.activeVT25)
      } else {
        LocalStorage.remove('activeVT25')
        this.VT25List = []
      }
    },
    async simulateWeightFromWheelLoader () {
      if (!this.activeVT25) {
        console.log('VT25List = "VT25 #1"')
        // Simulation Scale ids, if none found in service (no Scale is sending Weight results yet)
        // simulateWeightFromWheelLoader: click on headline in
        // Select active Scan Code via Scan Code button long press (contextmenu)
        this.VT25List = ['VT25 #1']
        this.activeVT25 = 'VT25 #1'
        this.selectedVT25 = 'VT25 #1'
      } else {
        const res = await WheelLoader.uploadWeight({
          VT25Id: this.activeVT25,
          Wk60WeightData: {
            AddedDate: DateUtil.getRealDate(Date.now()),
            NumberOfWeighings: 1,
            Status: 'W',
            TotalWeight: this.simulationWeight,
            Unit: 'kg',
            VoucherNumber: 1
          }
        })
        this.simulationWeight += 100
        if (res.failed) { console.log('Simulate uploadWeight() error') }
      }
    },

    async submit () {
      // Grab an update of the reg to get ScanXRegNo etc.
      const res2 = await WheelLoader.loadRegistration(this.wlReg.id)
      if (!res2.failed) {
        const comment = this.wlReg.Registration.Comment1
        this.wlReg.Registration = res2.data.Registration
        this.wlReg.Registration.Comment1 = comment
      }

      var convertedValue = this.checkWeightInput()
      if (convertedValue == null) return
      this.updateWeight(convertedValue)
      this.submitting = true
      const res = await WheelLoader.saveRegistration({
        Id: this.wlReg.id,
        RegistrationId: this.wlReg.registrationId,
        Facility: this.wlReg.facilityNo,
        FinishedDate: this.wlReg.finishedDate,
        FinishedBy: this.wlReg.finishedBy,
        Comment: '', // clear InUseBy
        Registration: this.wlReg.Registration
      })
      this.submitting = false
      if (!res.failed) {
        this.preventLeave = false
        this.$root.$message.showSuccess(this.form.weightNet + ' kg ' + this.$t('Saved').toLowerCase())
        this.$router.push({ name: this.redirectTo })
      }
    },
    async changeSetWeightStatus (val) {
      this.wlReg.Comment = val // Set button "Set weight (userName)" or clear button (val = '') // InUseBy
      /* const res = */ await WheelLoader.saveRegistration({
        Id: this.wlReg.id,
        RegistrationId: this.wlReg.registrationId,
        Facility: this.wlReg.facilityNo,
        Comment: this.wlReg.Comment,
        Registration: this.wlReg.Registration
      }, true)
      // When SaveOnlyComment is true we dont save the registration - and there should be no need to loaded and that is why below code is commented out
      // if (!res.failed) {
      //   if (val) {
      //     // Reload Pre registration, so Save works again
      //     this.wlReg.id = this.$route.params.id
      //     const res2 = await WheelLoader.loadRegistration(this.wlReg.id)
      //     if (!res2.failed) {
      //       this.form.weightNet = res2.data.Registration.WeightNet
      //       this.form.weightNetString = '' + this.form.weightNet
      //       console.log('XXXXX>> cp2 save/load reg')

      //       this.wlReg.registrationId = res2.data.RegistrationId
      //       this.wlReg.facilityNo = res2.data.Facility
      //       this.wlReg.finishedDate = res2.data.FinishedDate
      //       this.wlReg.finishedBy = res2.data.FinishedBy
      //       this.wlReg.CreatedBy = res2.data.CreatedBy
      //       this.wlReg.comment = res2.data.Comment
      //       this.wlReg.Registration = res2.data.Registration
      //     }
      //   }
      // }
    },
    isHide (fieldName) {
      return this.hiddenFields.some(h => h === fieldName)
    }
  },
  beforeDestroy () {
    // Stop live poll VT25/WK60 getWeight
    if (this.getLiveWeightTimer) {
      this.checkkingIsAlive = false
      clearInterval(this.getLiveWeightTimer)
    }
    if (this.getRegTimer) clearInterval(this.getRegTimer)
  },
  async mounted () {
    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    const res = await WheelLoader.getCurrentWeightIds()
    if (!res.failed && res.data.length) {
      this.VT25List = res.data
    }

    // Use Settings from cached user's corporatationDetails
    if (Security.user.corporationDetails) {
      this.enableVT25WeightIntegration = (Security.user.corporationDetails.find(d => d.Name === 'WheelLoader_Enable_VT25_Weight_Integration')?.Data1 === 'true')
      const defaultHidden = 'RequisitionNo2,Plant,Carrier,Comment' // New fields default hidden LSV/MITH. Remember to also add new defaults in Settings.vue and Registration.vue
      this.hiddenFields = (Security.user.corporationDetails.find(d => d.Name === 'WheelLoader_Fields_Hidden')?.Data1 ?? defaultHidden).split(',')
    }

    // Load current (stored) VT25 id
    const vt25 = LocalStorage.load('activeVT25')
    if (vt25) { this.activeVT25 = vt25 } else { LocalStorage.remove('activeVT25') }

    // Start Timer with getWeight check to VT25 box (and communication to WK60)
    this.getLiveWeightTimer = setInterval(async () => {
      // Only check IsAlive, if last check has ended
      if (this.enableVT25WeightIntegration && this.activeVT25) {
        this.checkkingIsAlive = true
        const res = await WheelLoader.getWeight({ VT25Id: this.activeVT25, ResetWeight: 'False' })
        if (res.failed) {
          this.isAlive = false
          this.displayWeight = '�'
          this.firstErrorStatus = 'No connection'
          this.$root.$message.showError('GetWeight for "' + this.activeVT25 + '" errors')
        } else {
          if (res.data.Status === 'W') {
            this.displayWeight = res.data.TotalWeight.toString() + ' kg'
            this.firstErrorStatus = ''
          } else {
            if (!this.firstErrorStatus) this.firstErrorStatus = res.data.Status
            this.displayWeight = '�'
          }
          if (!this.isAlive) this.isAlive = true
        }
        this.checkkingIsAlive = false
      }
    }, 2000)

    const disableConfirmTransfer = LocalStorage.load('disableConfirmTransferDialog')
    if (disableConfirmTransfer) {
      this.disableConfirmTransferDialog = true
    }

    if (this.$route.params.id) {
      this.wlReg.id = this.$route.params.id
      const res = await WheelLoader.loadRegistration(this.wlReg.id)
      if (!res.failed) {
        this.form.weightNet = res.data.Registration.WeightNet
        this.form.weightNetString = '' + this.form.weightNet

        this.wlReg.registrationId = res.data.RegistrationId
        this.wlReg.facilityNo = res.data.Facility
        this.wlReg.finishedDate = res.data.FinishedDate
        this.wlReg.finishedBy = res.data.FinishedBy
        this.wlReg.CreatedBy = res.data.CreatedBy
        this.wlReg.comment = res.data.Comment
        this.wlReg.Registration = res.data.Registration
      }
    } else {
      // ERROR
      // Calling this view incorrectly.
      this.$root.$message.showError(this.$t('Invalid registration id'))
    }

    this.$nextTick(() => {
      this.loading = false
    })

    this.changeSetWeightStatus(this.userName) // Set Weight Status to 'Set weight (userName)' // InUseBy
  }
}
</script>
